// React
import { FC, MouseEvent } from 'react'

// Custom
import {
  Exit,
  Icon,
  ModalBackground,
  ModalContainer,
  Text,
  Title,
} from './styled'
import CryFace from 'images/icons/cryFace.svg'
import ExitIcon from 'images/icons/exit.svg'
import Mail from 'images/icons/mail.svg'
import Skull from 'images/icons/skull.svg'
import StarImage from 'images/icons/starModal.svg'

type Props = {
  type?: 'success' | 'fail' | 'notFound'
  show: boolean
  onClose: () => void
}

const INFO = [
  {
    label: 'Yeah!',
    icon: Mail,
    msg: 'Your message was sent.',
    type: 'success',
  },
  {
    label: 'Oops!',
    icon: CryFace,
    msg: 'It’s not working yet.',
    type: 'fail',
  },
  {
    label: 'Sorry!',
    icon: Skull,
    msg: 'Nothing here.',
    type: 'notFound',
  },
]

const _getInfo = (type: string) => {
  const indexElement = INFO.findIndex((element) => element.type === type)
  return INFO[indexElement] || null
}

const Modal: FC<Props> = (props: Props) => {
  const { type = 'notFound', show = false, onClose } = props
  const info = _getInfo(type)

  const stopPropagation = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
  }

  return show ? (
    <ModalBackground onClick={onClose}>
      <ModalContainer onClick={stopPropagation}>
        <Exit src={ExitIcon} onClick={onClose} />
        <Icon src={info.icon} />
        <Title>{info.label}</Title>
        <Text>{info.msg}</Text>
        <Icon src={StarImage} />
        <Icon src={StarImage} />
      </ModalContainer>
    </ModalBackground>
  ) : null
}

export default Modal
